import {CallResult} from './api';

export async function postJsonAsync(endpoint: string, payload: any) {
    const rawResponse = await fetch(endpoint, {
        method: 'POST',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(payload)
    });

    const txt = await rawResponse.text();

    try {
        return JSON.parse(txt);
    } catch (e) {
        return null;
    }
}

export async function postFileAsync(endpoint: string, payload: string) {
    const formData = new FormData();
    formData.append('file', new Blob([payload]));

    const rawResponse = await fetch(endpoint, {
        method: 'POST',
        body: formData
    });

    const txt = await rawResponse.text();

    try {
        return JSON.parse(txt);
    } catch (e) {
        return null;
    }
}

export async function putJsonAsync(endpoint: string, payload: any) {
    const rawResponse = await fetch(endpoint, {
        method: 'PUT',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(payload)
    });

    const txt = await rawResponse.text();

    try {
        return JSON.parse(txt);
    } catch (e) {
        return null;
    }
}

export async function getJsonAsync(endpoint: string) {
    const rawResponse = await fetch(endpoint, {
        method: 'GET',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        }
    });

    return await rawResponse.json();
}

export async function deleteAsync(endpoint: string) {
    const rawResponse = await fetch(endpoint, {
        method: 'DELETE',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        }
    });

    const txt = await rawResponse.text();

    try {
        return JSON.parse(txt);
    } catch (e) {
        return null;
    }
}

export async function deleteJsonWithStatusAsync<TResult>(endpoint: string): Promise<CallResult<TResult>> {
    const rawResponse = await fetch(endpoint, {
        method: 'DELETE',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        }
    });

    var text: string;
    var json: any;

    try {
        text = await rawResponse.text();
    } catch (e) {
        text = null;
    }

    try {
        json = await rawResponse.json();
    } catch (e) {
        json = null;
    }

    return {
        status: rawResponse.status,
        response: {
            text: text,
            json: json
        }
    }
}
